import { Grid, GridItem, Text } from "@innovationnorway/lighthouse-components";
import cn from "classnames";
import React from "react";
import { ApplicationV2 } from "../../../main/models/application-v2";
import useWindowSize from "../../../utils/windowsSize";
import NotificationIcon from "../notificationIcon/notificationIcon";
import "./applicationButton.scss";

interface ApplicationButtonProps {
  application: ApplicationV2;
  activeApplication?: ApplicationV2;
  setActiveApplication: (application: ApplicationV2) => void;
}

const ApplicationButton = ({ application, activeApplication, setActiveApplication }: ApplicationButtonProps) => {
  const windowSize = useWindowSize();
  const breakGrid = windowSize.width < 1424;

  return (
    <button
      onClick={() => {
        setActiveApplication(application);
      }}
      tabIndex={0}
      key={`app-${application.id}`}
      className={cn("ApplicationButton", {
        ApplicationButton__active: activeApplication?.id === application.id
      })}
      aria-selected={activeApplication?.id === application.id}
    >
      <Grid>
        <GridItem spanLarge={8} spanMedium={8} spanSmall={3}>
          <Text variant="paragraph" className="data-hj-suppress">
            {application.title}
          </Text>
        </GridItem>
        <GridItem
          style={{ justifySelf: breakGrid ? "end" : "inherit", alignContent: "center" }}
          spanLarge={4}
          spanMedium={4}
          spanSmall={1}
        >
          <NotificationIcon notifications={application.tasks.filter((task) => task.isNew).length} />
        </GridItem>
      </Grid>
    </button>
  );
};

export default ApplicationButton;
